import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../Components/Seo";

const PREF_KEY = "aio_prefs_v1";

const loadPrefs = () => {
  try {
    return JSON.parse(localStorage.getItem(PREF_KEY) || "{}");
  } catch {
    return {};
  }
};

export default function Settings() {
  const navigate = useNavigate();
  const mobileNo = localStorage.getItem("userMobileNumber") || "";
  const [prefs, setPrefs] = useState(() => ({
    productAlerts: true,
    chatAlerts: true,
    showMobile: true,
    ...loadPrefs(),
  }));
  const [msg, setMsg] = useState("");
  const [notifState, setNotifState] = useState(
    typeof Notification !== "undefined" ? Notification.permission : "unsupported"
  );

  const savePref = (key, value) => {
    const next = { ...prefs, [key]: value };
    setPrefs(next);
    localStorage.setItem(PREF_KEY, JSON.stringify(next));
  };

  const requestNotifications = async () => {
    if (typeof Notification === "undefined") {
      setMsg("Is browser mein notifications support nahi hai");
      return;
    }
    const p = await Notification.requestPermission();
    setNotifState(p);
    setMsg(p === "granted" ? "✅ Notifications enable ho gaye!" : "Notifications block hain — browser settings mein allow karein");
    setTimeout(() => setMsg(""), 3000);
  };

  const clearCache = () => {
    if (!window.confirm("Local data clear karna hai? (Wallet, orders, social profile — sab hat jayega)")) return;
    ["aio_wallet_balance_v1", "aio_wallet_history_v1", "aio_orders_v1", "aio_social_profile", "aio_scratch_card_seen", "aio_prefs_v1"].forEach((k) => {
      Object.keys(localStorage)
        .filter((lk) => lk.startsWith(k))
        .forEach((lk) => localStorage.removeItem(lk));
    });
    setMsg("✅ Local data clear ho gaya");
    setTimeout(() => setMsg(""), 2500);
  };

  const handleLogout = () => {
    if (!window.confirm("Logout karna hai?")) return;
    localStorage.removeItem("userMobileNumber");
    navigate("/");
    window.location.reload();
  };

  if (!mobileNo) {
    navigate("/login");
    return null;
  }

  return (
    <div style={{ maxWidth: "620px", margin: "0 auto", padding: "24px" }}>
      <Seo title="Settings — Account & Preferences" description="AIO India settings — notifications, privacy, data aur account options manage karein." path="/settings" />

      <h2 style={{ margin: "0 0 18px", fontSize: "24px", fontWeight: 800, color: "#0f172a" }}>Settings</h2>

      {msg && (
        <div style={{ background: "#f0fdf4", border: "1px solid #86efac", color: "#15803d", padding: "12px 16px", borderRadius: "12px", marginBottom: "14px", fontWeight: 600, fontSize: "14px" }}>
          {msg}
        </div>
      )}

      <Section title="ACCOUNT">
        <Row label="📱 Mobile" value={`+91 ${mobileNo}`} />
        <Row label="👤 Profile" action="Edit karein" onClick={() => navigate("/profile")} />
        <Row label="📦 My Listings" action="Dekhein" onClick={() => navigate("/myadds")} />
        <Row label="💰 Wallet" action="Kholein" onClick={() => navigate("/wallet")} />
      </Section>

      <Section title="NOTIFICATIONS">
        <Row
          label="🔔 Push Notifications"
          value={notifState === "granted" ? "On" : notifState === "denied" ? "Blocked" : "Off"}
          action={notifState === "granted" ? undefined : "Enable"}
          onClick={notifState === "granted" ? undefined : requestNotifications}
        />
        <Toggle label="🛍️ Product Alerts" value={prefs.productAlerts} onChange={(v) => savePref("productAlerts", v)} />
        <Toggle label="💬 Chat Alerts" value={prefs.chatAlerts} onChange={(v) => savePref("chatAlerts", v)} />
      </Section>

      <Section title="PRIVACY">
        <Toggle label="👁️ Listing mein mobile dikhayein" value={prefs.showMobile} onChange={(v) => savePref("showMobile", v)} />
      </Section>

      <Section title="DATA & STORAGE">
        <Row label="🧹 Local data clear karein" action="Clear" onClick={clearCache} danger />
      </Section>

      <Section title="ABOUT">
        <Row label="ℹ️ AIO India Web" value="v1.0" />
        <Row label="🌐 Website" value="facebookindia.in" />
      </Section>

      <button
        onClick={handleLogout}
        style={{
          width: "100%", marginTop: "16px", padding: "13px", borderRadius: "12px",
          border: "1px solid #fecaca", background: "#fef2f2", color: "#dc2626",
          fontWeight: 800, fontSize: "15px", cursor: "pointer",
        }}
      >
        🚪 Logout
      </button>

      <p style={{ textAlign: "center", fontSize: "12px", color: "#94a3b8", marginTop: "16px" }}>
        Account delete karne ke liye support se contact karein
      </p>
    </div>
  );
}

const Section = ({ title, children }) => (
  <div style={{ background: "#fff", borderRadius: "16px", padding: "6px 0", marginBottom: "14px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
    <div style={{ padding: "12px 18px 6px", fontSize: "11px", fontWeight: 800, color: "#94a3b8", letterSpacing: "1px" }}>{title}</div>
    {children}
  </div>
);

const Row = ({ label, value, action, onClick, danger }) => (
  <div
    onClick={onClick}
    style={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "13px 18px", borderTop: "1px solid #f8fafc",
      cursor: onClick ? "pointer" : "default",
    }}
  >
    <span style={{ fontSize: "14px", fontWeight: 600, color: danger ? "#dc2626" : "#0f172a" }}>{label}</span>
    <span style={{ fontSize: "13px", color: onClick ? "#2563eb" : "#64748b", fontWeight: 600 }}>
      {action || value}
    </span>
  </div>
);

const Toggle = ({ label, value, onChange }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "13px 18px", borderTop: "1px solid #f8fafc" }}>
    <span style={{ fontSize: "14px", fontWeight: 600, color: "#0f172a" }}>{label}</span>
    <button
      onClick={() => onChange(!value)}
      style={{
        width: "46px", height: "26px", borderRadius: "999px", border: "none", cursor: "pointer",
        background: value ? "linear-gradient(135deg,#4f46e5,#7c3aed)" : "#cbd5e1",
        position: "relative", transition: "background 200ms",
      }}
    >
      <span
        style={{
          position: "absolute", top: "3px", left: value ? "23px" : "3px",
          width: "20px", height: "20px", borderRadius: "50%", background: "#fff",
          transition: "left 200ms", boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        }}
      />
    </button>
  </div>
);
